var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b306f94c-ab52-4d3d-9644-ccfa0085712c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["zz-platform-pages@zhuanzhuan"]={id:"b306f94c-ab52-4d3d-9644-ccfa0085712c"};
      